import angular from 'angular';

import summaryWidgetComponent from './summary.component';

export default angular.module('dbm.dashboard.components.widgets.summary', [])
.component('dbmSummaryWidget', summaryWidgetComponent)
.name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets/summary/index.js